import clsx from 'clsx';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { ConnectEcoSystemModal } from '@/modules/Onboarding';
import { Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import LinkIcon from '~/images/shared/Link.svg';
import PhoneIcon from '~/images/shared/Phone.svg';
import Question from '~/images/shared/QuestionMark.svg';

const HelpCenterMenuList: React.FC<{ openCollapse: boolean }> = ({
  openCollapse,
}) => {
  const { t } = useTranslation('navigation');
  const { openModal } = useModal();

  const linkStyle = () =>
    clsx(
      'flex mb-1 items-center cursor-pointer gap-2 rounded-lg aria-[current=false]:hover:bg-outline-default aria-[current=false]:text-text-default aria-[current=page]:bg-outline-default aria-[current=page]:text-primary-400',
      openCollapse ? 'p-2 justify-between' : 'p-1 justify-center'
    );

  return (
    <div className='flex flex-col gap-16 tablet:gap-0'>
      <Link
        prefetch={false}
        legacyBehavior
        passHref
        href='https://aydi.helpjuice.com/'
      >
        <a
          title={openCollapse ? '' : t('help')}
          target='_blank'
          className={linkStyle()}
        >
          <div className='flex items-center gap-2'>
            <div>
              <Question />
            </div>
            <Typography
              variant='subtitle2'
              className={clsx('duration-200', !openCollapse && 'hidden')}
            >
              {t('help')}
            </Typography>
            <div
              className={clsx(
                'text-12 duration-200',
                !openCollapse && 'hidden'
              )}
            >
              <LinkIcon />
            </div>
          </div>
        </a>
      </Link>
      <div
        title={openCollapse ? '' : t('help')}
        className={linkStyle()}
        onClick={() =>
          openModal(<ConnectEcoSystemModal />, {
            containerClassName: 'max-w-3xl',
          })
        }
      >
        <div className='flex items-center gap-2'>
          <div className='text-primary-400'>
            <PhoneIcon />
          </div>
          <Typography
            variant='subtitle2'
            className={clsx('duration-200', !openCollapse && 'hidden')}
          >
            {t('download-apps')}
          </Typography>
        </div>
      </div>
    </div>
  );
};
export default HelpCenterMenuList;
